"use client"

import * as Sentry from "@sentry/nextjs"
import { useEffect } from "react"

// Global error boundary that catches errors in the root layout
// This is required for Next.js App Router to handle errors at the root level
export default function GlobalError({
  error,
  reset
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to Sentry
    Sentry.captureException(error)
  }, [error])

  return (
    <html>
      <body>
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "1rem",
            backgroundColor: "#fecaca"
          }}>
          <div
            style={{
              maxWidth: "28rem",
              width: "100%",
              textAlign: "center"
            }}>
            <div style={{ marginBottom: "2rem" }}>
              <h1
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  color: "#000",
                  marginBottom: "1rem"
                }}>
                Något gick fel
              </h1>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#374151",
                  lineHeight: "1.625",
                  marginBottom: "2rem"
                }}>
                Ett oväntat fel har inträffat. Vi ber om ursäkt för besväret.
              </p>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem"
              }}>
              <button
                onClick={reset}
                style={{
                  width: "100%",
                  padding: "0.75rem 1.5rem",
                  backgroundColor: "#7c3aed",
                  color: "white",
                  border: "none",
                  borderRadius: "0.375rem",
                  fontSize: "1rem",
                  cursor: "pointer"
                }}>
                Försök igen
              </button>

              <button
                onClick={() => (window.location.href = "/")}
                style={{
                  width: "100%",
                  padding: "0.75rem 1.5rem",
                  backgroundColor: "transparent",
                  color: "#7c3aed",
                  border: "2px solid #7c3aed",
                  borderRadius: "0.375rem",
                  fontSize: "1rem",
                  cursor: "pointer"
                }}>
                Gå till startsidan
              </button>
            </div>

            {process.env.NODE_ENV === "development" && (
              <details style={{ marginTop: "2rem", textAlign: "left" }}>
                <summary
                  style={{
                    cursor: "pointer",
                    fontSize: "0.875rem",
                    color: "#6b7280"
                  }}>
                  Teknisk information (utveckling)
                </summary>
                <pre
                  style={{
                    marginTop: "1rem",
                    padding: "1rem",
                    backgroundColor: "#f3f4f6",
                    fontSize: "0.75rem",
                    color: "#000",
                    overflow: "auto",
                    borderRadius: "0.375rem"
                  }}>
                  {error.message}
                  {error.stack && `\n\n${error.stack}`}
                </pre>
              </details>
            )}
          </div>
        </div>
      </body>
    </html>
  )
}
